import { render, staticRenderFns } from "./productManageRecourse.vue?vue&type=template&id=43a66aca&scoped=true"
import script from "./productManageRecourse.vue?vue&type=script&lang=js"
export * from "./productManageRecourse.vue?vue&type=script&lang=js"
import style0 from "./productManageRecourse.vue?vue&type=style&index=0&id=43a66aca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a66aca",
  null
  
)

export default component.exports